import * as createPeriod from "@/api/periods/create";

export default {
	namespaced: true,
	state: {
		period: {},
		error: null,
	},
	getters: {
		readPeriod: (state) => state.period,
		readError: (state) => state.error,
	},
	mutations: {
		SET_PERIOD(state, payload) {
			state.period = payload;
		},
		SET_ERROR(state, payload) {
			state.error = payload;
		},
	},
	actions: {
		async createPeriod({ commit, getters, rootGetters }) {
			let token = rootGetters["loginStore/readToken"];
			let createPeriodRes = await createPeriod
				.createPeriod(token, getters.readPeriod)
				.then(() => {
					return true;
				})
				.catch((error) => {
					if (error.response) {
						let message =
							error.response.data.message ||
							error.response.data.detail[0].msg;
						message == "Token expired"
							? commit("loginStore/SET_ACCESS_TOKEN", null, {
									root: true,
							  })
							: message
							? commit("SET_ERROR", message)
							: commit("SET_ERROR", "Algo salió mal");
					} else {
						console.log(error);
						commit("SET_ERROR", error);
					}
				});
			return createPeriodRes;
		},
	},
};
